export enum StatusVote {
  default,
  notBalance,
  notBalanceRPV,
  voted,
  finished,
}
